import React, {forwardRef, useImperativeHandle, useState, useEffect, useRef,} from 'react';
import { useForm } from "react-hook-form"

import Dialog, { DialogRef } from "../../../components/Dialog";

export interface YosanDialogRef extends DialogRef {
  set: (values:YosanDialogValues) => void;
  clear: () => void;
}
export type YosanDialogValues = {
  typeOfBudgetSearchList: string[];
  typeOfBudgetYosanItemList: string[];
  runningTitleYosanItemList1: string[];
  runningTitleYosanItemList2: string[];
}
type YosanDialogProps = {
    id: string;
    values?: YosanDialogValues;
    onClose: (formData:any) => void;
};
const YosanDialog = forwardRef((props:YosanDialogProps, ref: React.Ref<YosanDialogRef> | undefined) => {
    
    const control = React.useRef<DialogRef>(null);
    
    const { register, getValues, watch, setValue} = useForm<YosanDialogValues>();

    const defaultValues = {
      'typeOfBudgetSearchList': [],
      'typeOfBudgetYosanItemList': [],
      'runningTitleYosanItemList1': [],
      'runningTitleYosanItemList2': []
    }
    const { id, values = defaultValues, onClose } = props;

    // チェック判定
    const isChecked = (list:string[], value: string) => {
      if (!list) return false;
      let check = false;
      list.map(function(v:string) {
          if (value === v) {
            check = true;
          }
      });
      return check;
    }

    // クリア処理
    const handleClear = () => {
      setValue('typeOfBudgetSearchList', []);
      setValue('typeOfBudgetYosanItemList', []);
      setValue('runningTitleYosanItemList1', []);
      setValue('runningTitleYosanItemList2', []);
    }
    // クローズイベント処理
    const handleClose = () => {
      const values = getValues();

      // 未チェックや単独チェックの場合
      // 配列として値が取れないため形式を変換する。
      let typeOfBudgetSearchList:string[] = [];
      if (typeof values.typeOfBudgetSearchList == 'object') {
        typeOfBudgetSearchList = values.typeOfBudgetSearchList;
      } else {
        typeOfBudgetSearchList = [values.typeOfBudgetSearchList];
      }
      let typeOfBudgetYosanItemList:string[] = [];
      if (typeof values.typeOfBudgetYosanItemList == 'object') {
        typeOfBudgetYosanItemList = values.typeOfBudgetYosanItemList;
      } else {
        typeOfBudgetYosanItemList = [values.typeOfBudgetYosanItemList];
      }
      let runningTitleYosanItemList1:string[] = [];
      if (typeof values.runningTitleYosanItemList1 == 'object') {
        runningTitleYosanItemList1 = values.runningTitleYosanItemList1;
      } else {
        runningTitleYosanItemList1 = [values.runningTitleYosanItemList1];
      }
      let runningTitleYosanItemList2:string[] = [];
      if (typeof values.runningTitleYosanItemList2 == 'object') {
        runningTitleYosanItemList2 = values.runningTitleYosanItemList2;
      } else {
        runningTitleYosanItemList2 = [values.runningTitleYosanItemList2];
      }

      onClose({
        'typeOfBudgetSearchList': typeOfBudgetSearchList,
        'typeOfBudgetYosanItemList': typeOfBudgetYosanItemList,
        'runningTitleYosanItemList1': runningTitleYosanItemList1,
        'runningTitleYosanItemList2': runningTitleYosanItemList2
      });
    }

    // 表示制御
    const isFirestRender = useRef(true);
    const watchTypeOfBudgetYosanItemList:string[] = watch('typeOfBudgetYosanItemList', defaultValues.typeOfBudgetYosanItemList);
    const [viewRunningTitlteYosanItemList1, setViewRunningTitlteYosanItemList1] = useState<boolean>(false);
    const [viewRunningTitlteYosanItemList2, setViewRunningTitlteYosanItemList2] = useState<boolean>(false);
    useEffect(() => {
      if (isFirestRender.current) { // 初回レンダリングをスキップ
        isFirestRender.current = false;
        return;
      }

      // 未チェックや単独チェックの場合
      // 配列として値が取れないため形式を変換する。
      let list:string[] = [];
      if (typeof watchTypeOfBudgetYosanItemList == 'object') {
        list = watchTypeOfBudgetYosanItemList;
      } else {
        list = [watchTypeOfBudgetYosanItemList];
      }

      // 一般会計
      if (isChecked(list, "0")) {
        setViewRunningTitlteYosanItemList1(true);
      } else {
        setViewRunningTitlteYosanItemList1(false);
        setValue('runningTitleYosanItemList1', []);
      }
      // 特別会計
      if (isChecked(list, "1")) {
        setViewRunningTitlteYosanItemList2(true);
      } else {
        setViewRunningTitlteYosanItemList2(false);
        setValue('runningTitleYosanItemList2', []);
      }
    }, [watchTypeOfBudgetYosanItemList]);

    // 
    useImperativeHandle(ref, () => ({
        show: () => {
          control.current?.show();
        },
        close: () => {
          control.current?.close();
        },
        set: (values:YosanDialogValues) => {
          setValue('typeOfBudgetSearchList', values.typeOfBudgetSearchList);
          setValue('typeOfBudgetYosanItemList', values.typeOfBudgetYosanItemList);
          setValue('runningTitleYosanItemList1', values.runningTitleYosanItemList1);
          setValue('runningTitleYosanItemList2', values.runningTitleYosanItemList2);
        },
        clear: () => {
          handleClear();
        }
    }));


    return (
        <Dialog id={id} ref={control} onClose={handleClose} onClear={handleClear}>
        <form>
          <div className="c-blk-head c-flex c-flex--between u-mt-0">
            <h2 id="budgetDocModalTitle" className="c-heading-lv2 c-flex__grow">予算書情報の絞り込み</h2>
          </div>
          <div className="c-blk-head">
            <h3 className="c-heading-lv3">予算種別で絞り込み</h3>
          </div>
          <div className="c-blk-txt">
            <p>検索対象に絞り込む予算種別をチェックしてください。</p>
          </div>
          <div className="c-blk-txt">
            <ul className="c-list-annotation">
              <li className="c-text-note">※予算種別を指定しない場合、全ての予算種別が検索対象となります。</li>
            </ul>
          </div>
          <div className="c-blk-txt c-blk-txt--lg">
            <fieldset className="c-checkbox-table">
              <legend className="c-checkbox-table-head">
                予算書情報の予算種別
              </legend>
              <div className="c-checkbox-table-body c-checkbox-table-body--col3">
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="typeOfBudgetSearchList_0" value="01" defaultChecked={isChecked(values.typeOfBudgetSearchList, "01")} {...register('typeOfBudgetSearchList')}/>
                    <label htmlFor="typeOfBudgetSearchList_0">当初予算</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="typeOfBudgetSearchList_1" value="02" defaultChecked={isChecked(values.typeOfBudgetSearchList, "02")} {...register('typeOfBudgetSearchList')}/>
                    <label htmlFor="typeOfBudgetSearchList_1">補正予算</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="typeOfBudgetSearchList_2" value="03" defaultChecked={isChecked(values.typeOfBudgetSearchList, "03")} {...register('typeOfBudgetSearchList')}/>
                    <label htmlFor="typeOfBudgetSearchList_2">暫定予算</label>
                  </span>
                </div>
              </div>
            </fieldset>
          </div>
          <div className="c-blk-head">
            <h3 className="c-heading-lv3">冊子名で絞り込み</h3>
          </div>
          <div className="c-blk-txt">
            <p>検索対象に絞り込む冊子名をチェックしてください。</p>
          </div>
          <div className="c-blk-txt">
            <ul className="c-list-annotation">
              <li className="c-text-note">※冊子を指定しない場合、全ての冊子が検索対象となります。</li>
              <li className="c-text-note">※一般会計、特別会計のいずれかを選択した場合、所管（国会、会計検査院、財務省等）による絞り込みの指定が可能です。</li>
            </ul>
          </div>
          <div className="c-blk-txt c-blk-txt--lg">
            <fieldset className="c-checkbox-table">
              <legend className="c-checkbox-table-head">
                予算書情報の冊子名
              </legend>
              <div className="c-checkbox-table-body c-checkbox-table-body--col2">
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="typeOfBudgetYosanItemList_0" value="0" defaultChecked={isChecked(values.typeOfBudgetYosanItemList, "0")} {...register('typeOfBudgetYosanItemList')}/>
                    <label htmlFor="typeOfBudgetYosanItemList_0">一般会計</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="typeOfBudgetYosanItemList_1" value="1" defaultChecked={isChecked(values.typeOfBudgetYosanItemList, "1")} {...register('typeOfBudgetYosanItemList')}/>
                    <label htmlFor="typeOfBudgetYosanItemList_1">特別会計</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="typeOfBudgetYosanItemList_2" value="2" defaultChecked={isChecked(values.typeOfBudgetYosanItemList, "2")} {...register('typeOfBudgetYosanItemList')}/>
                    <label htmlFor="typeOfBudgetYosanItemList_2">政府関係機関</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="typeOfBudgetYosanItemList_3" value="3" defaultChecked={isChecked(values.typeOfBudgetYosanItemList, "3")} {...register('typeOfBudgetYosanItemList')}/>
                    <label htmlFor="typeOfBudgetYosanItemList_3">財政法第２８条等</label>
                  </span>
                </div>
              </div>
            </fieldset>
          </div>
          <div className="c-blk-head">
            <h3 className="c-heading-lv3">所管で絞り込み</h3>
          </div>
          <div className="c-blk-txt">
            <p>検索対象に絞り込む所管をチェックしてください。</p>
          </div>
          <div className="c-blk-txt">
            <ul className="c-list-annotation">
              <li className="c-text-note">※冊子名の一般会計、特別会計のいずれかを選択した場合のみ、所管による絞り込みの指定が可能です。</li>
            </ul>
          </div>
          <div className="c-blk-txt c-blk-txt--lg" style={{display: (viewRunningTitlteYosanItemList1)?'': 'none'}}>
            <fieldset className="c-checkbox-table">
              <legend className="c-checkbox-table-head">
                予算書情報「一般会計」の所管
              </legend>
              <div className="c-checkbox-table-body c-checkbox-table-body--col3">
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_0" value="0" defaultChecked={isChecked(values.runningTitleYosanItemList1, "0")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_0">皇室費</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_1" value="1" defaultChecked={isChecked(values.runningTitleYosanItemList1, "1")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_1">国会</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_2" value="2" defaultChecked={isChecked(values.runningTitleYosanItemList1, "2")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_2">裁判所</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_3" value="3" defaultChecked={isChecked(values.runningTitleYosanItemList1, "3")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_3">会計検査院</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_4" value="4" defaultChecked={isChecked(values.runningTitleYosanItemList1, "4")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_4">内閣</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_5" value="5" defaultChecked={isChecked(values.runningTitleYosanItemList1, "5")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_5">内閣府</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_6" value="6" defaultChecked={isChecked(values.runningTitleYosanItemList1, "6")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_6">デジタル庁</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_29" value="29" defaultChecked={isChecked(values.runningTitleYosanItemList1, "29")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_29">防災庁</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_7" value="7" defaultChecked={isChecked(values.runningTitleYosanItemList1, "7")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_7">総務省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_8" value="8" defaultChecked={isChecked(values.runningTitleYosanItemList1, "8")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_8">法務省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_9" value="9" defaultChecked={isChecked(values.runningTitleYosanItemList1, "9")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_9">外務省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_10" value="10" defaultChecked={isChecked(values.runningTitleYosanItemList1, "10")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_10">財務省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_11" value="11" defaultChecked={isChecked(values.runningTitleYosanItemList1, "11")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_11">文部科学省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_12" value="12" defaultChecked={isChecked(values.runningTitleYosanItemList1, "12")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_12">厚生労働省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_13" value="13" defaultChecked={isChecked(values.runningTitleYosanItemList1, "13")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_13">農林水産省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_14" value="14" defaultChecked={isChecked(values.runningTitleYosanItemList1, "14")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_14">経済産業省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_15" value="15" defaultChecked={isChecked(values.runningTitleYosanItemList1, "15")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_15">国土交通省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_16" value="16" defaultChecked={isChecked(values.runningTitleYosanItemList1, "16")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_16">環境省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_17" value="17" defaultChecked={isChecked(values.runningTitleYosanItemList1, "17")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_17">防衛省</label>
                  </span>
                </div>
              </div>
            </fieldset>
            <fieldset className="c-checkbox-table">
              <legend className="c-checkbox-table-head">
                予算書情報「一般会計」の旧所管
              </legend>
              <div className="c-checkbox-table-body c-checkbox-table-body--col3 c-checkbox-table-body--gray">
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_18" value="18" defaultChecked={isChecked(values.runningTitleYosanItemList1, "18")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_18">総理府</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_19" value="19" defaultChecked={isChecked(values.runningTitleYosanItemList1, "19")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_19">大蔵省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_20" value="20" defaultChecked={isChecked(values.runningTitleYosanItemList1, "20")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_20">文部省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_21" value="21" defaultChecked={isChecked(values.runningTitleYosanItemList1, "21")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_21">厚生省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_22" value="22" defaultChecked={isChecked(values.runningTitleYosanItemList1, "22")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_22">農林省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_23" value="23" defaultChecked={isChecked(values.runningTitleYosanItemList1, "23")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_23">通商産業省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_24" value="24" defaultChecked={isChecked(values.runningTitleYosanItemList1, "24")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_24">運輸省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_25" value="25" defaultChecked={isChecked(values.runningTitleYosanItemList1, "25")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_25">郵政省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_26" value="26" defaultChecked={isChecked(values.runningTitleYosanItemList1, "26")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_26">労働省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_27" value="27" defaultChecked={isChecked(values.runningTitleYosanItemList1, "27")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_27">建設省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList1_28" value="28" defaultChecked={isChecked(values.runningTitleYosanItemList1, "28")} {...register('runningTitleYosanItemList1')}/>
                    <label htmlFor="runningTitleYosanItemList1_28">自治省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell"></div>
              </div>
            </fieldset>
          </div>
          <div className="c-blk-txt c-blk-txt--lg" style={{display: (viewRunningTitlteYosanItemList2)?'': 'none'}}>
            <fieldset className="c-checkbox-table">
              <legend className="c-checkbox-table-head">
                予算書情報「特別会計」の所管
              </legend>
              <div className="c-checkbox-table-body c-checkbox-table-body--col3">
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_0" value="0" defaultChecked={isChecked(values.runningTitleYosanItemList2, "0")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_0">総務省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_1" value="1" defaultChecked={isChecked(values.runningTitleYosanItemList2, "1")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_1">法務省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_2" value="2" defaultChecked={isChecked(values.runningTitleYosanItemList2, "2")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_2">財務省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_3" value="3" defaultChecked={isChecked(values.runningTitleYosanItemList2, "3")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_3">文部科学省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_4" value="4" defaultChecked={isChecked(values.runningTitleYosanItemList2, "4")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_4">厚生労働省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_5" value="5" defaultChecked={isChecked(values.runningTitleYosanItemList2, "5")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_5">農林水産省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_6" value="6" defaultChecked={isChecked(values.runningTitleYosanItemList2, "6")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_6">経済産業省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_7" value="7" defaultChecked={isChecked(values.runningTitleYosanItemList2, "7")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_7">国土交通省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_8" value="8" defaultChecked={isChecked(values.runningTitleYosanItemList2, "8")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_8">内閣府、総務省及び財務省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_9" value="9" defaultChecked={isChecked(values.runningTitleYosanItemList2, "9")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_9">内閣府及び厚生労働省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_10" value="10" defaultChecked={isChecked(values.runningTitleYosanItemList2, "10")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_10">財務省、文部科学省及び経済産業省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_11" value="11" defaultChecked={isChecked(values.runningTitleYosanItemList2, "11")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_11">財務省、経済産業省及び環境省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_12" value="12" defaultChecked={isChecked(values.runningTitleYosanItemList2, "12")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_12">財務省及び国土交通省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_13" value="13" defaultChecked={isChecked(values.runningTitleYosanItemList2, "13")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_13">文部科学省、経済産業省及び環境省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_14" value="14" defaultChecked={isChecked(values.runningTitleYosanItemList2, "14")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_14">内閣府、文部科学省、経済産業省及び環境省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_15" value="15" defaultChecked={isChecked(values.runningTitleYosanItemList2, "15")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_15">
                      国会、裁判所、会計検査院、内閣、内閣府、復興庁、総務省、法務省、外務省、財務省、文部科学省、厚生労働省、農林水産省、経済産業省、国土交通省、環境省及び防衛省
                    </label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_16" value="16" defaultChecked={isChecked(values.runningTitleYosanItemList2, "16")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_16">
                      国会、裁判所、会計検査院、内閣、内閣府、デジタル庁、復興庁、総務省、法務省、外務省、財務省、文部科学省、厚生労働省、農林水産省、経済産業省、国土交通省、環境省及び防衛省
                    </label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_32" value="32" defaultChecked={isChecked(values.runningTitleYosanItemList2, "32")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_32">
                      国会、裁判所、会計検査院、内閣、内閣府、デジタル庁、防災庁、復興庁、総務省、法務省、外務省、財務省、文部科学省、厚生労働省、農林水産省、経済産業省、国土交通省、環境省及び防衛省
                    </label>
                  </span>
                </div>
              </div>
            </fieldset>
            <fieldset className="c-checkbox-table">
              <legend className="c-checkbox-table-head">
                予算書情報「特別会計」の旧所管
              </legend>
              <div className="c-checkbox-table-body c-checkbox-table-body--col3 c-checkbox-table-body--gray">
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_17" value="17" defaultChecked={isChecked(values.runningTitleYosanItemList2, "17")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_17">大蔵省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_18" value="18" defaultChecked={isChecked(values.runningTitleYosanItemList2, "18")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_18">文部省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_19" value="19" defaultChecked={isChecked(values.runningTitleYosanItemList2, "19")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_19">厚生省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_20" value="20" defaultChecked={isChecked(values.runningTitleYosanItemList2, "20")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_20">農林省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_21" value="21" defaultChecked={isChecked(values.runningTitleYosanItemList2, "21")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_21">通商産業省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_22" value="22" defaultChecked={isChecked(values.runningTitleYosanItemList2, "22")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_22">運輸省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_23" value="23" defaultChecked={isChecked(values.runningTitleYosanItemList2, "23")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_23">郵政省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_24" value="24" defaultChecked={isChecked(values.runningTitleYosanItemList2, "24")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_24">労働省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_25" value="25" defaultChecked={isChecked(values.runningTitleYosanItemList2, "25")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_25">建設省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_26" value="26" defaultChecked={isChecked(values.runningTitleYosanItemList2, "26")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_26">総理府、大蔵省及び通商産業省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_27" value="27" defaultChecked={isChecked(values.runningTitleYosanItemList2, "27")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_27">総理府、大蔵省及び自治省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_28" value="28" defaultChecked={isChecked(values.runningTitleYosanItemList2, "28")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_28">大蔵省及び自治省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_29" value="29" defaultChecked={isChecked(values.runningTitleYosanItemList2, "29")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_29">大蔵省、通商産業省及び労働省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_30" value="30" defaultChecked={isChecked(values.runningTitleYosanItemList2, "30")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_30">大蔵省及び建設省</label>
                  </span>
                </div>
                <div className="c-checkbox-table-body__cell">
                  <span className="c-check-wrap">
                    <input type="checkbox" id="runningTitleYosanItemList2_31" value="31" defaultChecked={isChecked(values.runningTitleYosanItemList2, "31")} {...register('runningTitleYosanItemList2')}/>
                    <label htmlFor="runningTitleYosanItemList2_31">大蔵省、運輸省及び建設省</label>
                  </span>
                </div>
              </div>
            </fieldset>
          </div>
        </form>
        </Dialog>
    );
});
export default YosanDialog;